import { RacquetballIcon } from './RacquetballIcon';

/**
 * author: Google
 * id 0E46DC98-E185-4B26-A4E9-FC1CEC750172
 * name racquetball
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/racquetball.svg
 * tags
 * - Sport 
 */
export const LacrosseIcon = RacquetballIcon;
export default LacrosseIcon